export default {
  computed: {
    loadingAnimationFinished() {
      return this.$store.state.loadingAnimationFinished
    },
  },
  data() {
    return {
      // animation: null,
      isActive: false,
      animTriggered: false
    };
  },
  watch: {
    loadingAnimationFinished() {
      this.animateIn();
    },
    isActive() {
      if (this.loadingAnimationFinished) {
        this.animateIn()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setValues();
      // this.setTrigger();

      setTimeout((() => {
          if (this.loadingAnimationFinished) {
            this.animateIn();
          }
        }
      ), 500)
    });
  },
  methods: {
    setValues: function () {
      if (!this.$refs.animHeader) return false;

      this.$refs.animHeader.querySelectorAll(".text-anim").forEach(((element) => {
          this.$gsap.set(element, {
            yPercent: 140,
            scaleY: 1.5,
            skewX: -10,
            transformOrigin: "center"
          })
        }
      ))


      this.$refs.animHeader.querySelectorAll(".img-anim-wrapper").forEach(((element) => {
          this.$gsap.set(element, {
            yPercent: -100
          })

          const otherElement = element.querySelector(".img-anim-holder img");

          if (otherElement) {
            this.$gsap.set(otherElement, {
              yPercent: 100
            });
          }
        }
      ))
    },
    // setTrigger: function () {
    //   // ToDo do we even need this?
    //   // var e = this;
    //   this.animation = this.$ScrollTrigger.create({
    //     trigger: this.$refs.introBlock,
    //     start: "top 80%",
    //     end: "bottom 80%",
    //     onToggle: function (t) {
    //       if (t.isActive) {
    //         t.isActive = true;
    //       }
    //     },
    //     onEnter: function (t) {
    //       if (t.isActive) {
    //         t.isActive = true;
    //       }
    //     }
    //   })
    // },
    animateIn() {
      if (this.animTriggered) return;
      this.animTriggered = true;
      const tl = this.$gsap.timeline();

      tl.to(this.$refs.animHeader.querySelectorAll(".text-anim"), {
        delay: 0.1,
        duration: 0.8,
        yPercent: 0,
        scaleY: 1,
        skewX: 0,
        ease: "power4.out",
        stagger: 0.15 // 0.2 seconds between each element's animation start
      }, 0);

      this.$refs.animHeader.querySelectorAll(".img-anim-wrapper").forEach((element) => {
        tl.to(element, {
          duration: 1,
          yPercent: 0,
          ease: "power3.inOut"
        }, 0.5); // 0.5 indicates these animations start 0.1 seconds after the previous set
      });

      this.$refs.animHeader.querySelectorAll(".img-anim-holder img").forEach((element) => {
        tl.to(element, {
          duration: 1,
          yPercent: 0,
          ease: "power3.inOut"
        }, 0.5); // 0.5 indicates these animations start 0.1 seconds after the previous set
      });
    },
  },
  // beforeDestroy: function () {
  //   if (this.animation) {
  //     this.animation.kill();
  //   }
  // },
};
